import { useState } from 'react';

export const useTable = () => {
  const defaultPageSize = 10;
  const sizePageOptions = [10, 50, 100, 500];
  const defaultCurrent = 1;
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [current, setCurrent] = useState(defaultCurrent);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);

  const setTotalItem = (value) => {
    setTotal(value);
  };

  const setCurrentPage = (value) => {
    setCurrent(value);
  };

  const onShowSizeChange = (_currentSize, size) => {
    setPageSize(size);
  };

  const onSelectChange = (selectedRowDataKeys, selectedRows) => {
    setSelectedRowsData(selectedRows);
    setSelectedRowKeys(selectedRowDataKeys);
  };

  const onClearAllSelected = () => {
    setSelectedRowsData([]);
    setSelectedRowKeys([]);
  };

  return {
    total,
    current,
    pageSize,
    defaultPageSize,
    sizePageOptions,
    onShowSizeChange,
    setTotalItem,
    setCurrentPage,
    onSelectChange,
    onClearAllSelected,
    selectedRowKeys,
    selectedRowsData,
  };
};
